import React from "react";
import { connect } from "react-redux";
import { Trans, withTranslation } from "react-i18next";
import { Translation } from "react-i18next";
import { withRouter } from "react-router-dom";
import {
  getEquipmentDetails,
  deleteEquipmentDetails,
  getEquipmentList,
  getEquipmentUsed,
  getEquipmentMakeModelDetails,
} from "../Actions/EquipmentManagementAPI";
import { confirmAlert } from "react-confirm-alert";
import axios from "axios";
import API from "../helpers/api";
import { toast } from "react-toastify";
import Modal from "react-bootstrap/Modal";
import swal from "sweetalert";
import i18n from "./DropdownLanguage/i18n";

let currentuser = JSON.parse(localStorage.getItem("currentUser"));

let searchData = {
  EquipmentId:0,
  Equipment: "",
  MakeId:0,
  ModelId:0,
  Make:"",
  Model:"",
  ServiceType:"",
  EquipmentType: "",
  Category: "",
  ServiceTypeId:0,
  capacity: "",
  PageNumber: 1,
  PageSize: 20,
};
class EquipmentMgmtDetail extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      id: "",
      modalIsOpen: false,
      delete: "",
    };
  }
  componentDidUpdate() {
    window.onpopstate = (e) => {
      //your code...
      this.props.dispatch({ type: "ShowSidePan", data: false });
    };
  }
  componentDidMount() {
    const { match, dispatch } = this.props;
    const { params } = match;
    const { id } = params;
    dispatch(getEquipmentDetails(id));
    dispatch(getEquipmentMakeModelDetails(id));
  }
  hideSidePanel = () => {
    this.props.dispatch({ type: "ShowSidePan", data: false });
    this.props.history.push("/Home/EquipmentManagement");
  };

  ConfirmAlert(item) {
    const{dispatch,t}=this.props;
      confirmAlert({
        message: `${t("confirmAlertMessage.DeleteMsg")}`,
        buttons: [
          {
            label: `${t("confirmAlertMessage.Yes")}`,
            onClick: () => {
          let url = `${API.DeleteEquipment}?Equipmentid=${item.equipmentId}&ModifiedBy=${currentuser.name}`;
          axios.delete(url)
             .then((response) => {
            dispatch(getEquipmentList(searchData));
            this.hideSidePanel()
             dispatch({
             type: "deleteEquipmentDetailSuccess",
             data: response.data,
            });
          toast.success(`${t("CommonText.CommonDelete")}`, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        })
        .catch((error) => {
          dispatch({
            type: "deleteEquipmentDetailFailure",
            error: "ERROR",
          });
        });
            }
          },
          {
            label: `${t("confirmAlertMessage.No")}`,
            onClick: () => { }
          }
        ]
      }); 
    }

  handleInputChange(e) {
    let nodeName = e.target.name;
    this.state[nodeName] = e.target.value;
    this.setState({});
  }

  render() {
    const { EquipmentUsed, EquipmentDetail,t } = this.props;
    return (
      <div className="pb-3">
        <Modal
          size="md"
          show={this.state.modalIsOpen}
          onHide={() => this.setState({ modalIsOpen: false, delete: "" })}
          aria-labelledby="example-modal-sizes-title-sm"
          backdrop="static"
          centered="true"
          animation="true"
        >
          <Modal.Header closeButton>
            <Modal.Title id="example-modal-sizes-title-sm">
            {t("confirmAlertMessage.DeleteMsg")}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <table style={{ width: "100%" }}>
              <tr style={{ lineHeight: "30px" }}>
                <strong>{t("content.totalship")} : </strong>
                <span>{EquipmentUsed ? EquipmentUsed.shipCount : 0}</span>
              </tr>
              <tr style={{ lineHeight: "30px" }}>
                <strong>{t("EquipmentManagementScreenContent.ShipNames")} : </strong>
                <span>
                  {EquipmentUsed
                    ? EquipmentUsed.shipNames === null
                      ? "No Ships"
                      : EquipmentUsed.shipNames.toString()
                    : ""}
                </span>
              </tr>
              {/* <div
                                className="col-lg-6 "
                            > */}
              <span class="text-muted">
                <i>{t("EquipmentManagementScreenContent.DeleteNote")}</i>
              </span>
              <br></br>
              <input
                className="form-control mt-2"
                style={{ width: "auto" }}
                type="text"
                name="delete"
                placeholder={t("CommonText.Delete")}
                onChange={(e) => this.handleInputChange(e)}
                value={this.state.delete}
              ></input>
              {/* </div> */}
              <div
                className="form-group search-btn-col mt-4"
                style={{ textAlign: "end" }}
              >
                <button
                  className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                  type="submit"
                  onClick={() => this.deleteEquipmentDetails(EquipmentDetail)}
                >
                  {" "}
                  {t("confirmAlertMessage.Ok")}{" "}
                </button>
                <button
                  className="btn btn-light text-uppercase txtside-btn txtht-btn ml-3"
                  type="button"
                  // onClick={() => this.ClearInput()}
                  onClick={() =>
                    this.setState({ modalIsOpen: false, delete: "" })
                  }
                >
                  {" "}
                  {t("ComplianceandBudgetScreen.Cancel")}{" "}
                </button>
              </div>
            </table>
          </Modal.Body>
        </Modal>
        {this.renderCardData()}
      </div>
    );
  }

  renderCardData() {
    const { EquipmentDetail,EquipmentMakeModelCardDetail,t } = this.props;
    const isArabic = i18n.language === 'arab'
    return (
      <div className="full-height">
        <div className="pt-3">
          <div className="row">
            <div className="col-lg-12">
              <div className="row resource-list-auth-date">
                <div className="panel-box search-filter-box">
                  <button
                    className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                    onClick={() => this.hideSidePanel()}
                    style={{display:'inline-flex',alignItems:'center'}}
                  >
                    <span style={{marginTop:'-1px'}}>&larr;</span>{t("CommonText.Return")}
                  </button>
                  <div
                    className="card mt-2 MM-card-header"
                    style={{ backgroundColor: "white" }}
                  >
                    <div
                      className="card-body"
                      style={{
                        padding: "0rem",
                        backgroundColor: "#1a3464",
                        color: "white",
                      }}>
                      <h5
                        className="card-title ml-2 mt-2"
                        style={{ color: "092a51" }}>
                        {t("ShipDetailsScreen.EquipmentDetails")}
                      </h5>
                    </div>
                    <div className="pt-3 pb-3 search-filter-box">
                      <div className="row">
                        <div className="col-sm-6">
                          <label className="form-label">{t("EquipmentManagementScreenContent.Name")} : </label>
                          <span>
                            {" "}
                            {EquipmentDetail
                              ? EquipmentDetail.equipmentName
                              : ""}
                          </span>
                        </div>
                        <div className="col-sm-6">
                          <label className="form-label">{t("ShipEquipmentStatusScreen.Type")} : </label>
                          <span>
                            {" "}
                            {EquipmentDetail
                              ? EquipmentDetail.equipmentType
                              : ""}
                          </span>
                        </div>
                        <div className="col-sm-6">
                          <label className="form-label">{t("TopPaneContent.Category")} : </label>
                          <span>
                            {" "}
                            {EquipmentDetail ? EquipmentDetail.category : ""}
                          </span>
                        </div>
                        <div className="col-lg-6">
                          <label className="form-label">
                          {t("ShipEquipmentStatusScreen.Capacity")} / {t("ShipEquipmentStatusScreen.Size")} :{" "}
                          </label>
                          <span>
                            {" "}
                            {EquipmentDetail ? EquipmentDetail.capacity : ""}
                          </span>
                        </div>
                        
                        {/* <div className="col-lg-6">
                          <label className="form-label">
                          {t("EquipmentManagementScreenContent.AddonEquipment")} :{" "}
                          </label>
                          <span>
                            {" "}
                            {EquipmentDetail
                              ? EquipmentDetail.isAddOnEquipment === true
                                ? "Yes"
                                : "No"
                              : ""}
                          </span>
                        </div> */}
                        <div className="col-lg-6">
                          <label className="form-label">
                          {t("EquipmentTypeScreen.Title")} :{" "}
                          </label>
                          <span>
                            {" "}
                            {EquipmentDetail ? EquipmentDetail?.equipmentType : ""}

                          </span>
                        </div>
                        {/* <div className="col-lg-6">
                          <label className="form-label"> */}
                          {/* {t("EquipmentTypeScreen.Title")} :{" "}Manual*/}
                          {/* </label>
                          <span> */}
                            {" "}
                            {/* {EquipmentDetail ? EquipmentDetail?.equipmentType : ""} */}

                          {/* </span>
                        </div> */}
                      </div>
                    </div>
                    <div
                      className="card-body"
                      style={{
                        padding: "0rem",
                        backgroundColor: "#1a3464",
                        color: "white",
                      }}
                    >
                      <h5
                        className="card-title ml-2 mt-2"
                        style={{ color: "092a51" }}
                      >
                        {t("ClassScreen.ApplicableServices")}
                      </h5>
                    </div>
                    <div className="pt-3 search-filter-box history-box">
                      {EquipmentMakeModelCardDetail&& EquipmentMakeModelCardDetail.length !==0
                        ? EquipmentMakeModelCardDetail.map((item) => (
                            <div
                              className="card MM-card-content mb-2 click"
                              style={{
                                backgroundColor: "#f0f0f0",
                                overflow: "hidden",
                                position: "relative",
                              }}
                            >
                              <div className="p-3">
                                <div className="resource-list-auth-date">
                                  <div className="row">
                                    <div className="col-md-11 col-sm-10 col-10 m-auto">
                                      <div className="row">
                                        <div className="col-sm-6 mb-2">
                                          <span className={`${isArabic ? 'arabic' : ''}`}>
                                            <strong>{t("ShipEquipmentStatusScreen.Make")}  </strong>
                                            <strong>:</strong>
                                           {item?.makeName}{" "}
                                          </span>
                                        </div>
                                        <div className="col-sm-6 mb-2">
                                          <span className={`${isArabic ? 'arabic_ship' : ''}`}>
                                            <strong>{t("ShipEquipmentStatusScreen.Model")}  </strong>
                                            <strong>:</strong>
                                           
                                          </span>
                                          {item?.modelName}{" "}
                                        </div>
                                    
                                        <div className="col-sm-6">
                                          <span className={`${isArabic ? 'arabic_ship' : ''}`}>
                                            <strong>{t("content.Servicetype")}  </strong>
                                            <strong>:</strong>
                                            
                                          </span>
                                          {item?.serviceType}{" "}
                                        </div>
                                        <div className="col-sm-6">
                                          <span>
                                            <strong>{t("ComplianceandBudgetScreen.Type")}: </strong>
                                            {item?.isShore?"Shore":"Ship"}{" "}
                                          </span>
                                        </div>
                                      </div>
                                    </div>
                                 
                                  </div>
                                </div>
                              </div>
                            </div>
                          ))
                        :( <>
                        <div
                        className="card"
                        style={{ overflow: "hidden", position: "relative" }}
                      >
                        <div class="container">
                          <h6 className="resource-list-title no-item-card">
                            !--{t("CommonText.NoItem")} --!
                        </h6>
                        </div>
                      </div></>
                      ) }
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-lg-12 pb-2 pt-2">
                      <div
                        className="search-btn-col mt-1"
                        style={{ textAlign: "right" }}
                      >
                        <button
                          className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                          type="submit"
                          onClick={() =>
                            this.EditEquipmentDetails(EquipmentDetail)
                          }
                        >
                          {" "}
                          {t("IntervelScreen.Edit")}{" "}
                        </button>
                        <button
                          className="btn btn-light text-uppercase txtside-btn txtht-btn ml-3"
                          type="button"
                          onClick={() => this.ConfirmAlert(EquipmentDetail)}
                        >
                          {" "}
                          {t("CommonText.Delete")}{" "}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
  EditEquipmentDetails(item) {
    this.props.history.push(`/Home/EditEquipment/${item.equipmentId}`);
    this.props.dispatch({ type: "AttchmentUploaded", data: "" });
    this.props.dispatch({ type: "GAttchmentUploaded", data: "" });
    this.props.dispatch({ type: "ShowSidePan", data: false });
  }
  deleteEquipmentDetails(item) {
    const { dispatch,t } = this.props;
    if (this.state.delete === "") {
      // swal("Error!", `${t("EquipmentManagementScreenContent.DeleteWarningMsg")}`, "warning");
      swal({
        title: t('SwalError.ErrorTitle'), 
        text: t('EquipmentManagementScreenContent.DeleteMsg'),  
        icon: 'warning',  
        buttons: {
          confirm: {
            text: t('confirmAlertMessage.Ok')
          }
        }
      });
    } else if (this.state.delete === "Delete") {
      let equipment = {
        equipmentId: item.equipmentId,
        category: item.category,
        equipmentName: item.equipmentName,
        equipmentType: item.equipmentType,
        annually: false,
        biannually: false,
        fiveYearly: false,
        tenYearly: false,
        isDeleted: true,
        modifiedBy: currentuser.name,
        confirmDelete: this.state.delete,
      };
      item.serviceType.map((x) => {
        if (x.toLowerCase() === "annually") {
          equipment.annually = true;
        }
        if (x.toLowerCase() === "biannually") {
          equipment.biannually = true;
        }
        if (x.toLowerCase() === "fiveyearly") {
          equipment.fiveYearly = true;
        }
        if (x.toLowerCase() === "tenyearly") {
          equipment.tenYearly = true;
        }
      });
      let url = `${API.postEquipment}`;
      axios
        .put(url, equipment)
        .then((response) => {
          dispatch(getEquipmentList(searchData));
          this.hideSidePanel();
          toast.success(`${t("CommonText.CommonDelete")}`, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
          dispatch({
            type: "deleteEquipmentDetailSuccess",
            data: response.data,
          });
        })
        .catch((error) => {
          dispatch({
            type: "deleteEquipmentDetailFailure",
            error: "ERROR",
          });
        });
    } else {
      // swal(
      //   "Error!",
      //   `${t("EquipmentManagementScreenContent.DeleteMsg")}`,
      //   "warning"
      // );
      swal({
        title: t('SwalError.ErrorTitle'), 
        text: t('EquipmentManagementScreenContent.DeleteMsg'),  
        icon: 'warning',  
        buttons: {
          confirm: {
            text: t('confirmAlertMessage.Ok')
          }
        }
      });
    }
  }
}
function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}
function mapStateToProps(state) {
  return {
    EquipmentDetail: state.MasterScreenReducer.EquipmentDetail,
    EquipmentUsed: state.MasterScreenReducer.EquipmentUsed,
    EquipmentMakeModelCardDetail: state.MasterScreenReducer.EquipmentMakeModel,
  };
}
export default withTranslation()(withRouter(
  connect(mapStateToProps, mapDispatchToProps)(EquipmentMgmtDetail)));
